import { styled } from 'next-yak'

import * as colors from '../../constants/colors.ts'

export const DiscreetText = styled.span`
  font-size: 12px;
  font-weight: ${(props) => (props.light ? 300 : 400)};
  color: ${colors.TEXT_TERTIARY};
`
